import React from 'react';
import { colors } from '../../styles/styles';

/**
 * Reusable filter button component with active indicator
 */
const FilterButton = ({ 
  onClick, 
  hasActiveFilters, 
  style
}) => {
  return (
    <button
      onClick={onClick}
      aria-label="Filter"
      style={{
        background: hasActiveFilters ? `${colors.accent.white}20` : 'none',
        border: 'none',
        borderRadius: '4px',
        padding: '4px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        position: 'relative',
        ...style
      }}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
          d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z" 
          stroke={hasActiveFilters ? 'black' : colors.textSecondary} 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
      
      {/* Indicator dot for active filters */}
      {hasActiveFilters && (
        <span style={{
          position: 'absolute',
          top: '2px',
          right: '2px',
          width: '10px',
          height: '10px',
          borderRadius: '50%',
          backgroundColor: colors.accent.white,
        }}></span>
      )}
    </button>
  );
};

export default FilterButton; 